module.exports = "<button ng-click=\"$ctrl.click()\" type=\"button\" class=\"btn btn-danger ladda-button ac-color\" data-style=\"expand-right\"></button>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/ui/ladda-button/ladda-button.html
// module id = 512
// module chunks = 0